import {IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {PaletteColorsEnum} from '../../../../libs/shared/ui/src/styles/paletteModel';
import {RuleBundleCategoriesEnum} from './ruleBundleCategory';

interface RuleTypeIcon {
  small: {
    unfilled: IconName;
    filled: IconName;
  };
  regular: {
    filled: IconName;
  };
}

const RULE_TYPES_ICONS: Record<RuleBundleCategoriesEnum, RuleTypeIcon> = {
  [RuleBundleCategoriesEnum.ASSIGN]: {
    small: {unfilled: 'assignSmall', filled: 'assignFilledSmall'},
    regular: {filled: 'assignFilled'},
  },
  [RuleBundleCategoriesEnum.ARCHIVE]: {
    small: {unfilled: 'archiveSmall', filled: 'archiveFilledSmall'},
    regular: {filled: 'archiveFilled'},
  },
  [RuleBundleCategoriesEnum.COMMENT]: {
    small: {unfilled: 'channelChatOutlineSmall', filled: 'channelChatSmall'},
    regular: {filled: 'chatFilled'},
  },
  [RuleBundleCategoriesEnum.MOVE]: {
    small: {unfilled: 'moveRightSmall', filled: 'moveRightFilledSmall'},
    regular: {filled: 'moveRightFilled'},
  },
  [RuleBundleCategoriesEnum.NOTIFY]: {
    small: {unfilled: 'subscribeSmall', filled: 'bellSmall'},
    regular: {filled: 'bell'},
  },
  [RuleBundleCategoriesEnum.REPLY]: {
    small: {unfilled: 'sendSmall', filled: 'sendFilledSmall'},
    regular: {filled: 'sendFilled'},
  },
  [RuleBundleCategoriesEnum.TAG]: {
    small: {unfilled: 'tagSmall', filled: 'tagFilledSmall'},
    regular: {filled: 'tagFilled'},
  },
  [RuleBundleCategoriesEnum.SLA]: {
    small: {unfilled: 'slaSmall', filled: 'slaFilledSmall'},
    regular: {filled: 'slaFilled'},
  },
};

export function getRuleTypeIcon(ruleType: RuleBundleCategoriesEnum | null): RuleTypeIcon {
  if (!ruleType) {
    return {small: {unfilled: 'gearSmall', filled: 'gearFilledSmall'}, regular: {filled: 'gearFilled'}};
  }

  return RULE_TYPES_ICONS[ruleType];
}

export const RULE_TYPE_PALETTE: Record<RuleBundleCategoriesEnum, PaletteColorsEnum> = {
  [RuleBundleCategoriesEnum.ASSIGN]: PaletteColorsEnum.BLUE,
  [RuleBundleCategoriesEnum.ARCHIVE]: PaletteColorsEnum.GREEN,
  [RuleBundleCategoriesEnum.COMMENT]: PaletteColorsEnum.PINK,
  [RuleBundleCategoriesEnum.MOVE]: PaletteColorsEnum.PURPLE,
  [RuleBundleCategoriesEnum.NOTIFY]: PaletteColorsEnum.YELLOW,
  [RuleBundleCategoriesEnum.REPLY]: PaletteColorsEnum.TEAL,
  [RuleBundleCategoriesEnum.TAG]: PaletteColorsEnum.RED,
  [RuleBundleCategoriesEnum.SLA]: PaletteColorsEnum.ORANGE,
};

export function getRuleTypePaletteColor(ruleType: RuleBundleCategoriesEnum | null): PaletteColorsEnum {
  if (!ruleType) {
    return PaletteColorsEnum.GREY;
  }

  return RULE_TYPE_PALETTE[ruleType];
}
